import { baseApi } from 'core/api/base'
import {
  CreateExternalMcpInput,
  IExternalMcp,
  UpdateExternalMcpInput,
} from 'lauria/types/externalMcp'
import { generatePath } from 'react-router'

const PROMPT_EXTERNAL_MCPS_ENDPOINT = '/prompts/:promptId/external-mcps'
const PROMPT_EXTERNAL_MCP_ENDPOINT =
  '/prompts/:promptId/external-mcps/:idExternalMcp'

const externalMcpApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createExternalMcp: builder.mutation<
      IExternalMcp,
      { promptId: number; body: CreateExternalMcpInput }
    >({
      query: ({ promptId, body }) => ({
        url: generatePath(PROMPT_EXTERNAL_MCPS_ENDPOINT, {
          promptId: promptId.toString(),
        }),
        method: 'POST',
        body,
      }),
      invalidatesTags: (result, error, { promptId }) => [
        { type: 'Prompt', promptId: { promptId } },
      ],
    }),
    updateExternalMcp: builder.mutation<
      IExternalMcp,
      {
        promptId: number
        idExternalMcp: number
        body: UpdateExternalMcpInput
      }
    >({
      query: ({ promptId, idExternalMcp, body }) => ({
        url: generatePath(PROMPT_EXTERNAL_MCP_ENDPOINT, {
          promptId: promptId.toString(),
          idExternalMcp: idExternalMcp.toString(),
        }),
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, { promptId }) => [
        { type: 'Prompt', promptId: { promptId } },
      ],
    }),
    deleteExternalMcp: builder.mutation<
      void,
      { promptId: number; idExternalMcp: number }
    >({
      query: ({ promptId, idExternalMcp }) => ({
        url: generatePath(PROMPT_EXTERNAL_MCP_ENDPOINT, {
          promptId: promptId.toString(),
          idExternalMcp: idExternalMcp.toString(),
        }),
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { promptId }) => [
        { type: 'Prompt', promptId: { promptId } },
      ],
    }),
  }),
})

export const {
  useCreateExternalMcpMutation,
  useUpdateExternalMcpMutation,
  useDeleteExternalMcpMutation,
} = externalMcpApi
export { externalMcpApi }
